<template>
    <div>
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'Autos'}" v-bind:class="{[settingsLinkActiveClass]: ['Autos', 'Auto'].indexOf(settingLink)+1}">
                <span>Транспорт</span>
            </router-link>
        </li>
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'StatusReasons'}" v-bind:class="{[settingsLinkActiveClass]: ['StatusReasons', 'StatusReason'].indexOf(settingLink)+1}">
                <span>Признаки статусов заявок</span>
            </router-link>
        </li>        
    </div>
</template>
<script>
    export default {
        name: 'dals-settings-menu',
        sort: 9,
        module: 'deals',
        data() {
            return {
                module: 'deals',
                sort: 9
            }
        },
        created() {},
        computed: {
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }
        },
        methods: {},
        watch: {}
    }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?703b9594